/**
 * Волна C (docs/MIGRATION_ROUTER.md §5). Было: <PrivateRoute path='/cook/:id(\d+)'>.
 * Regex-параметр :id(\d+) эмулируется numericIdShell: не-число → 404.
 */
import { createFileRoute } from '@tanstack/react-router';
import { numericIdShell } from '../compat/shells';
import Article from '@routes/Article';

export const Route = createFileRoute('/cook/$id')({
  component: numericIdShell(Article, '/cook/:id(\\d+)')
});
